export const FAST_API_URL = 'https://fastapi.dev.torsunov.pro';
